import { render } from "./RequestTenantReference.vue?vue&type=template&id=0f0be69c&scoped=true&ts=true"
import script from "./RequestTenantReference.vue?vue&type=script&lang=ts"
export * from "./RequestTenantReference.vue?vue&type=script&lang=ts"

import "./RequestTenantReference.vue?vue&type=style&index=0&id=0f0be69c&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0be69c"]])

export default __exports__